/**
 * msAdmin 应用入口
 * 基于 JWT 认证的微服务管理平台
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import { App as AntApp } from "antd/es";
import { handleTokenFromUrl } from "./utils/tokenFromUrl";

// 添加全局Promise rejection处理
window.addEventListener("unhandledrejection", (event) => {
  // 检查是否是角色删除相关的错误
  if (event.reason && event.reason.message && event.reason.message.includes("该角色下还有管理员")) {
    // 阻止默认的错误处理（在控制台显示Uncaught Error）
    event.preventDefault();
    return;
  }

  // 对于其他错误，也阻止默认处理
  event.preventDefault();
});

// 声明全局类型
declare global {
  interface Window {
    // JWT 相关全局变量
    msAuthToken?: string;
  }
}

// 处理URL中的token（如果存在）
handleTokenFromUrl();

// 创建React根实例并渲染应用
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(<App />);

// 应用已启动
console.log("msAdmin 应用已启动");
